// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"e7fb5af1","48":"2569ebd1","58":"cadd8a89","204":"9996ef44","337":"35b18879","455":"d11c7df5","584":"4996170b","645":"57722d50","704":"14a9ef43","864":"256336bf","892":"96be5688","988":"d703e1bb"}[chunkId] + ".chunk.js";
};